import config from '@config';
import { EXTENSIONS, MEDIA_TYPE, CROPPING_EXTENSIONS } from '@api/media/constants';

export const getImage = (obj = {}, name = 'image') => ({
  id: obj[`${name}Id`],
  edited: obj[`${name}Edited`],
  fileName: obj[`${name}FileName`],
  title: obj[`${name}Title`],
});

export const buildSrc = ({ fileName, thumbnail = false, path = '' }) =>
  `${thumbnail ? config.media.thumbnailUrl : config.media.url}/${path}${fileName}`;

export const getSrc = ({ file, media, edited, thumbnail }) =>
  file?.imageUrl ||
  (edited && buildSrc({ fileName: edited })) ||
  (media?.fileName &&
    buildSrc({
      fileName: media.fileName,
      thumbnail: media.type === MEDIA_TYPE.IMAGE && thumbnail,
      path: media.type === MEDIA_TYPE.DOCUMENT ? 'document/' : '',
    }));

export const encodeCrop = ({ media, edits: { resize, extract, ...edits } = {} }) =>
  btoa(
    JSON.stringify({
      bucket: media.bucket,
      key: media.fileName,
      edits: {
        // Specific order, because for image handler it matters
        // Also it can be null from API, so change it to undefined to remove when stringifying
        // Otherwise image handler can't crop because of null edit
        extract: extract || undefined,
        resize: resize || undefined,
        ...edits,
      },
    }),
  );

export const decodeCrop = (base64) => {
  const edit = atob(base64 || '' /* not in args because can be null */) || '{}';
  return JSON.parse(edit);
};

export const reСrop = (edit, size) => {
  const decodedCrop = decodeCrop(edit);
  const { resize: omitted, ...restEdits } = decodedCrop.edits || {};
  const newEdit = encodeCrop({ media: { fileName: decodedCrop.key }, edits: { resize: size, ...restEdits } });
  return newEdit;
};

export const getFileName = (file, media) => file?.name || media?.fileName;

export const getExtension = (fileName) => {
  const [, extension = ''] = /^.*(\..*)$/.exec(fileName) || [];
  return extension.toLowerCase();
};

export const isCroppable = (media) => CROPPING_EXTENSIONS.includes(getExtension(media?.fileName));

export const getType = (file, media) => {
  const fileName = getFileName(file, media);
  const extension = getExtension(fileName);

  const type = Object.values(MEDIA_TYPE).find((mediaType) => {
    return EXTENSIONS[mediaType].includes(extension);
  });

  if (!type) return MEDIA_TYPE.UNKNOWN;

  return type;
};

export const getTypeName = (type) => {
  if (type === MEDIA_TYPE.IMAGE) return 'image';
  if (type === MEDIA_TYPE.DOCUMENT) return 'document';

  return 'file';
};

export const getInfo = ({ file, media, thumbnail }) => {
  const type = getType(file, media);

  return {
    fileName: getFileName(file, media),
    src: getSrc({ file, media, thumbnail }),
    type,
    typeName: getTypeName(type),
  };
};
